import { SVGProps } from "react";

const ToastWarningIcon = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect x="0.5" width="32" height="32" rx="16" fill="#F9DC5C" fillOpacity="0.08" />
      <path
        d="M16.5 12.4502V16.4502M16.5 25C11.5294 25 7.5 20.9706 7.5 16C7.5 11.0294 11.5294 7 16.5 7C21.4706 7 25.5 11.0294 25.5 16C25.5 20.9706 21.4706 25 16.5 25ZM16.5498 19.4502V19.5502L16.4502 19.5498V19.4502H16.5498Z"
        stroke="#F9DC5C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ToastWarningIcon;
